import "./SignIn.scss";
import { observer } from "mobx-react";
import { authStore } from "../stores";
import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { Background, Logo, Button, TextInput } from "../lib";
import ResetPassword from "./ResetPassword";
import bkg from "../assets/assess-bkg-04.png";
import { firebase } from "../constants";

class SignIn extends Component {
  state = {
    email: "",
    password: "",
    resetting: false,
  };

  signInWithSSO = async () => {
    try {
      const provider = new firebase.auth.SAMLAuthProvider("saml.unstuckwp");
      const result = await firebase.auth().signInWithPopup(provider);
      console.log({ result });
    } catch (error) {
      console.log({ error });
      alert(error.message);
    }
  };

  signInWithEmail = (e) => {
    e.preventDefault();
    authStore.signIn(this.state.email, this.state.password);
  };

  handleReset = () => {
    this.setState({ resetting: !this.state.resetting });
  };

  handleChange = (field) => {
    return (value) => {
      this.setState({ [field]: value });
    };
  };

  render() {
    if (authStore.auth) {
      return <Redirect to="/assess" />;
    }

    return (
      <div className="SignIn">
        <Background src={bkg} />
        {this.state.resetting ? (
          <ResetPassword onBack={this.handleReset} />
        ) : (
          <form className="SignIn_form" onSubmit={this.signInWithEmail}>
            <Logo />
            <Button
              styleType="primary"
              type="button"
              onClick={this.signInWithSSO}
            >
              Sign in with Unstuck
            </Button>
            <div className="SignIn_divider">
              <hr />
              <h6>OR</h6>
            </div>
            <TextInput
              type="email"
              placeholder="Email"
              value={this.state.email}
              onChange={this.handleChange("email")}
            />
            <TextInput
              type="password"
              placeholder="Password"
              value={this.state.password}
              onChange={this.handleChange("password")}
              autoFocus={false}
            />
            <Button
              className="SignIn_forgot"
              onClick={this.handleReset}
              styleType="blank"
            >
              Forgot your password?
            </Button>
            {authStore.error && (
              <p className="SignIn_error">{authStore.error}</p>
            )}
            <Button className="SignIn_action" styleType="default" type="submit">
              Sign in with email
            </Button>
            <footer className="SignIn_footer">
              <p>
                Don’t have an account?{" "}
                <a href="https://theunstuckgroup.com/my-account/">Sign Up</a>
              </p>
            </footer>
          </form>
        )}
      </div>
    );
  }
}

SignIn.displayName = "SignIn";

export default observer(SignIn);



// WEBPACK FOOTER //
// ./src/auth/SignIn.js